import React from "react";
import {Calendar, Car, Exchange, Vector7} from "../../../assets/icons";
import {useLanguage} from "../../../hooks/LanguageContext";
import {vehicleSizeOptions} from "../../booking/BookingInfoStep1";
import {Link} from "react-router-dom";

const QuickBooking = () => {
	const { direction } = useLanguage();

	const handleOnSubmit = (event) => {
		event.preventDefault();
	};

	const headingText =
		direction === "rtl"
			? "ابدأ رحلة الحجز بسهولة.."
			: "Start your booking journey easily..";
	const fromLocationText = direction === "rtl" ? "من الموقع" : "From location";

	const toLocationText = direction === "rtl" ? "الى موقع" : "To location";

	const dateText = direction === "rtl" ? "تاريخ التحميل" : "Loading Date";

	const carTypeText = direction === "rtl" ? "حجم السيارة" : "Vehicle size";

	const searchText = direction === "rtl" ? "اكمل الحجز" : "Continue Booking";

	return (
		<div
			className={`md:w-[1102px] w-full flex flex-col items-start gap-4 md:gap-8 z-[2] ${
				direction === "rtl" ? "text-right" : "text-left"
			}`}
		>
			<h3 className="headline-3-ar text-grayscale-600">{headingText}</h3>

			<form
				onSubmit={handleOnSubmit}
				className="w-full h-full flex flex-col items-start gap-8"
			>

				<section className="w-full flex flex-col  items-start gap-4 relative">
					<div className=" w-full flex  flex-row justify-center md:justify-start xl:justify-between items-center gap-2 md:gap-6">
						<div className="space-y-2">
							<div className="flex items-center gap-2">
								<span className="md:w-[12px] md:h-[12px] w-[10px] h-[10px] bg-primary-700 rounded-full"></span>
								<span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">
      							{fromLocationText}
    							</span>
								<Vector7 className="hidden md:block" />
							</div>
							<input
								type="text"
								placeholder={fromLocationText}
								className="w-full md:w-[300px] lg:w-[400px]  md:h-[50px] h-12 border-2 border-primary-700 text-grayscale-400 py-3 px-4 bg-bg-light placeholder:text-grayscale-400 text-base font-medium leading-[23.52px]"
							/>
						</div>

						<Exchange className="translate-y-1/3 md:translate-y-0" />
						<div className="space-y-2">
							<div className="flex items-center gap-2">
								<span className="md:w-[12px] md:h-[12px] w-[10px] h-[10px] bg-primary-700 rounded-full"></span>
								<span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">{toLocationText}</span>
							</div>
							<input
								type="text"
								placeholder={toLocationText}
								className="w-full md:w-[300px] lg:w-[400px]  md:h-[50px] h-12 border-2 border-primary-700 text-grayscale-400 py-3 px-4 bg-bg-light shadow-custom-shadow placeholder:text-grayscale-400 text-base font-medium leading-[23.52px]"
							/>
						</div>
					</div>
					<div className=" w-full flex  flex-col md:flex-row justify-start xl:justify-between  items-center gap-6 md:gap-20">
						<div className="space-y-2">
							<div className="flex items-center gap-2">
								<Car className="text-primary-800" />
								<span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">
      							{carTypeText}
    							</span>

							</div>
							<select
								name="shipmentType"
								className="w-full md:w-[300px] lg:w-[400px] md:h-[50px] border-2 border-primary-700  p-2"
							>
								<option value="" disabled={true} >اختيار</option>
								{vehicleSizeOptions.map((option, index) => (
									<option key={index} value={option}>
										{option}
									</option>
								))}
							</select>
						</div>


						<div className="space-y-2 mr-2">
							<div className="flex items-center gap-2">
								<Calendar className="text-primary-800" />
								<span className="text-primary-700 headline-4-ar !font-bold whitespace-nowrap">
      							{dateText}
    							</span>

							</div>
							<input
								type="date"
								className="  md:w-[300px] lg:w-[400px] md:h-[50px] h-12 border-2 border-primary-700 text-grayscale-400 py-[20px] px-[30px] bg-bg-light shadow-custom-shadow placeholder:text-grayscale-400 text-base font-medium leading-[23.52px]"
							/>
						</div>


					</div>
					<div className="flex ">
						<Link to="/booking" target="_blank" className="flex items-center justify-center whitespace-nowrap md:w-[150px] w-full md:h-[50px] h-12 text-center bg-primary-700 rounded-[10px] md:py-[13px] py-1 px-4 text-lg font-bold  text-bg-light transition-colors hover:bg-primary-600">
							{searchText}
						</Link>
					</div>



				</section>
			</form>
		</div>
	);
};

export default QuickBooking;
